// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__2mJSm","label":"LabeledBox_label__20cVi"};